import { render, staticRenderFns } from "./ChatWizard.vue?vue&type=template&id=0595090c"
import script from "./ChatWizard.vue?vue&type=script&lang=js"
export * from "./ChatWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports